<span class="badge badge-danger pointer" (click)="closeAllModals()"><i class="fas fa-times"></i></span>
